import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useComplexBilling from '../../invoices/useComplexBilling';

const BillingInput = ({value, onChange}) => {
  const fixValueFromValue = (value) => {
    if (! value || ! value["0"]) { return null }
    return value["0"]
  }
  const complexValueFromValue = (value) => {
    if (! value || Object.keys(value) < 2) { return null }
    return Object.keys(
      value
    ).sort(
      (a,b)=>(parseFloat(a) - parseFloat(b))
    ).map((k,i, arr)=>(
      {
        from: parseInt(k),
        to: (arr.at(i+1) ? parseInt(arr.at(i+1)) : ""),
        value: value[k]
      }
    ))
  }
  const { t } = useTranslation();
  const [fix, setFix] = useState(fixValueFromValue(value));
  const { complex, setComplex, updateFrom, updateTo, updateValue, add: complexAdd, pop } = useComplexBilling(complexValueFromValue(value))
  const toValue = () => {
    if( fix && fix != "" && ! complex ) {
      return { "0": parseInt(fix) }
    } else if(complex) {
      const res = {}
      complex.forEach((row) => {
        res[row.from.toString()] = row.value
      })
      return res
    } else {
      null
    }
  }
  const isToInvald = (i) => {
    return !( complex[i].to === "" || complex[i].from <= complex[i].to)
  }
  const isValueInvalid = (i) => {
    return (isNaN(complex[i].value) || complex[i].value < 0 )
  }
  const disabledAdd = () => {
    if ( !complex ) { return false }
    for (let i = 0; i < complex.length; i++) {
      if(isValueInvalid(i)){ return true }
      if(isToInvald(i)){ return true }
    }
    if ( ! complex.at(-1).to ) { return true }
    return false
  }
  const add = () => {
    if (!complex) {
      setComplex([{from: "0", to: "", value: fix ?? ""}])
      setFix(null)
    } else {
      complexAdd()
    }
  }
  const disabledRemove = () => {
    return (!complex)
  }
  const remove = () => {
    if ( complex.length == 1 ) {
      setFix(complex[0].value)
      setComplex(null)
    } else {
      pop()
    }
  }
  useEffect(() => {
    onChange(toValue())
  }, [complex, fix])

  return (<>
    { !complex &&
      <Form.Group>
        <Form.Label>{t("billing.cpm")}</Form.Label>
        <Form.Control type="number" value={fix} onChange={(e)=>{setFix(e.target.value)}} placeholder="Value" />
      </Form.Group>
    }
    { complex &&
      <>
        <Row>
          <Col>
            <Form.Label>{t('from')}</Form.Label>
          </Col>
          <Col>
            <Form.Label>{t('to')}</Form.Label>
          </Col>
          <Col>
            <Form.Label>{t('cpm')}</Form.Label>
          </Col>
        </Row>
        {
          complex.map((elt, i) => {
            return (
              <Row key={i}>
                <Form.Group as={Col} controlId={`from${i}`}>
                  <Form.Control
                    required
                    type="number"
                    step="1"
                    disabled
                    value={elt.from}
                    onChange={(e) => {updateFrom(i)(e.target.value)}}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId={`to${i}`}>
                  <Form.Control
                    type="number"
                    step="1"
                    disabled={false}
                    value={elt.to}
                    isInvalid={isToInvald(i)}
                    onChange={(e) => {
                      updateTo(i)(e.target.value)
                    }}
                  />
                  <Form.Control.Feedback tooltip={true} type="invalid">
                    {t("publisher.cpmToValidation")}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} controlId={`value${i}`}>
                  <Form.Control
                    required
                    type="number"
                    step="1"
                    value={elt.value}
                    disabled={false}
                    isInvalid={isValueInvalid(i)}
                    onChange={(e) => {updateValue(i)(e.target.value)}}
                  />
                  <Form.Control.Feedback tooltip={true} type="invalid">
                    {t("publisher.cpmValueInvalid")}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
            )
          })
        }
      </>
    }
    <div className="mb-3">
      <Button onClick={add} disabled={disabledAdd()}>add</Button>
      <Button onClick={remove} disabled={disabledRemove()}>remove</Button>
    </div>
  </>)
}

export default BillingInput